<template>
<v-col class="pa-0">
    <belongstomany-show v-if="project.id && !loading"
        :collection="products"
        :headers="headersProducts"
        title="Task/Prodotti"
        downloadCSV>
        <template slot="table-footer">
            <v-row class="ma-0 pa-0 justify-center">
                <v-col class="col-lg-3 col-md-4 col-sm-4 col-xs-6 pt-0 px-0">                            
                    <v-list two-line class="background-2">
                        <v-list-item>
                            <v-list-item-action>
                                <v-icon color="primary">mdi-currency-eur</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Totale Imponibile Prodotti</v-list-item-title>
                                <v-list-item-subtitle>{{ productSubtotal | currency }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>
            </v-row>
        </template>
    </belongstomany-show>
</v-col>
</template>

<script>

    import BelongstomanyShow from '@/components/common/BelongstomanyShow'

    export default {
        name: 'project-products',
        components: {
            BelongstomanyShow
        },

        props: {
            project: Object,
        },

        data() {
            return {
                loading: false,
                products: [],
                headersProducts: [
                    {
                        align: 'left',
                        value: 'tasklist',
                        text: 'Tasklist',
                    },
                    {
                        align: 'left',
                        value: 'task',
                        text: 'Task',
                    },
                    {
                        align: 'left',
                        value: 'subtotal',
                        type: 'currency',
                        text: 'Totale'
                    },
                ],
            }
        },

        computed: {

            productSubtotal() {
                return this.products ?  this.products.reduce((acc, product) => acc + parseFloat(product.subtotal), 0) : 0
            },
            
        },        

        methods: {
            initialize() {
                this.loading = true
                this.axios.get('taskboardproducts/' + this.project.id).then(response => {
                    this.products = response.data.data
                    this.loading = false

                }, response => {
                    this.loading = false
                })                
            }
        },

        watch: {
            project: {
                handler() {
                    this.initialize()
                }
            }
        },

        mounted() {
            this.initialize()
            this.$eventBusUtility.$on('updatedTaskboard', () => {
                this.initialize()
            })            
        },

        beforeDestroy() {
			this.$eventBusUtility.$off('updatedTaskboard')
		},
    }
</script>

<style>

</style>